/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABMElEQVR4nN2UsUrEQBCGg6Biq/hOKdyZiTjOb2GbTtDCOr2H1hb253N4iO8QPdEXsFE4QfRk41kcCbdJXAsdGAiBfN/O/EuS5F9XmqarlJk6wSWxlST2RII3/1y9y0xVdaUX3Iltk+CeBNOFzTYmQtYaXBTFEgkGQbDMtxM789+GT8446QqnbwnjdCF8i/ekL5xm7RmNcB8WsT38VECCx8bgibATAT79ygO79d37axdLwBjWJxDcxhIQ27hBYC8RJ3iuC9gmESeYNAnKiIKyHjJj+KshM5tFEnz4K18T5Hm+XP24woBXxzhU1fWka5HYcVBAOEr6VKq66Rh3IYHOTu4E1y3CHlVwVV0jxk2bHYvsb1TTso2CYQuuKoETO+9wQw567B4Dx/beUnLRK4M/W5/THoH7z/t++gAAAABJRU5ErkJggg==)
 */
export const ChatMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M12.2 22c.5-.01.67-.84.37-1.24A3 3 0 0 1 15 16h5.84c.2 0 .38-.12.46-.3a10 10 0 1 0-17.74 1.66c.12.19.1.44-.04.61l-2.07 2.37A1 1 0 0 0 2.2 22h10Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
